if ($('footer#footer').length) {
  $('footer#footer').after($('.footer-bottom').removeClass('container').wrapInner('<div class="container"></div>'))
  $('#signature').removeAttr('style').append($('footer#footer .signature'));
  $('footer#footer').before($('footer#footer .contactBlocksWrap'));
  $('footer#footer').before($('.newsletterForm'));
  $('.newsletterForm .inner').append($('footer#footer #formNewsletterWidget'))
  $('.custom-footer__newsletter .newsletter-header').append($('footer#footer .newsletterForm'))
      $(document).on('click', '.custom-footer>div h4', function () {
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });

    $('footer#footer .logoSocial ul.customSocialIcons').append($('footer#footer .contact-box li span.facebook').closest('li').clone());
    $('footer#footer .logoSocial ul.customSocialIcons').append($('footer#footer .contact-box li span.instagram').closest('li').clone());
    $('footer#footer .logoSocial ul.customSocialIcons').append($('footer#footer .contact-box li span.tiktok').closest('li').clone());
    $('footer#footer .logoSocial ul.customSocialIcons').append($('footer#footer .contact-box li span.youtube').closest('li').clone());
    $('footer#footer').before($('footer#footer .instagramFeed'));
    $(".instagram-widget>a").each(function () {
        $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>')
    });
    $('#formNewsletterWidget button[type=submit]').text(translation('prihlasitse'));
    $('#formNewsletterWidget input[type="email"]').attr('placeholder', translation('vasEmail'));
    customFooterFunctions();
    
   // $('#customerLogin').prepend($('footer#footer .loginBenefits'));
    
    
    /*$('#formLoginIncluded .social-login-buttons').after($('#formLoginIncluded .login-wrapper .password-helper'));
    $('.top-navigation-bar .container, nav#navigation>div.navigation-in').append(`
      <div class="customContactBar">
        <div class="left">
          <span>${openDays}</span>
        </div>
        <div class="center">
          <p class="contactPhone">
            <a href="tel:${telRostliny}">${telRostliny}</a>
            <span class="info">${translation('inforostliny')}</span>
          </p>
          <p class="contactPhone">
            <a href="tel:${telObjednavky}">${telObjednavky}</a>
            <span class="info">${translation('infoobjednavky')}</span>
          </p>
        </div>
        <div class="last">
          <a href="${contactUrl}">${translation('dalsiKontakty')}</a>
        </div>
      </div>  
    `)*/
   
    //  $('#customerLogin').prepend('<div class="registerPlus">'+registrationBenefits+'</div>')
}
else{
   var storageFooter = 'footer_' + window.location.hostname;
  $(document).ready(function () {
      const cachedFooter = sessionStorage.getItem(storageFooter);
      if (cachedFooter) {
          $('.overall-wrapper').append(
              '<footer id="footer">' + cachedFooter + '</footer>'
          );
          customFooterFunctions();
      } else {
          $.ajax({
              type: "GET",
              dataType: "html",
              timeout: 1e4,
              cache: true,
              url: "/",
              success: function (e) {
                  const doc = shoptet.common.createDocumentFromString(e);
                  const footerHtml = $(doc).find("footer#footer").html();
                  if (footerHtml) {
                      $('.overall-wrapper').append(
                          '<footer id="footer">' + footerHtml + '</footer>'
                      );
                      sessionStorage.setItem(storageFooter, footerHtml);
                  }
                  customFooterFunctions();
              }
          });
      }
  });
}

function customFooterFunctions(){
  $('#customerLogin').prepend($('footer#footer .loginBenefits'));
    
   $('.top-navigation-bar .container, nav#navigation>div.navigation-in').append(`
      <div class="customContactBar">
        <div class="left">
          <span>${openDays}</span>
        </div>
        <div class="center">
          <p class="contactPhone">
            <a href="tel:${telRostliny}">${telRostliny}</a>
            <span class="info">${translation('inforostliny')}</span>
          </p>
          <p class="contactPhone">
            <a href="tel:${telObjednavky}">${telObjednavky}</a>
            <span class="info">${translation('infoobjednavky')}</span>
          </p>
        </div>
        <div class="last">
          <a href="${contactUrl}">${translation('dalsiKontakty')}</a>
        </div>
      </div>  
    `);
    supportHoursOpen();
}